// Based on: https://austingil.com/prevent-browser-refresh-url-changes-route-navigation-vue
// and https://router.vuejs.org/guide/advanced/navigation-guards.html#in-component-guards

import Swal from 'sweetalert2'
export default {
    data() {
        return {
            _title: null,
            _message: null,
            _allowNavigation: true,
            _onNavigateHandler: null,
        }
    },
    beforeMount() {
        window.addEventListener('beforeunload', this._preventNavigation)
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this._preventNavigation)
    },
    beforeRouteLeave(to, from, next) {
        if (this._allowNavigation) {
            return next()
        }

        const handler = this._onNavigateHandler
        if (handler) {
            return handler(from, to).then(next)
        }

        this._defaultNavigateHandler().then(next)
    },
    mounted() {
        const options = this.$options.navigationOptions

        if (!options) {
            return this.setAllowNavigation(true)
        }

        if (options.title) {
            this._setTitle(options.title)
        }

        if (options.message) {
            this._setMessage(options.message)
        }

        if (options.onNavigateHandler) {
            this.setOnNavigateHandler(options.onNavigateHandler)
        }

        if (options.allowNavigation) {
            this.setAllowNavigation(options.allowNavigation)
        }
    },
    methods: {
        setAllowNavigation(value) {
            this._allowNavigation = value
        },
        setOnNavigateHandler(handler) {
            this._onNavigateHandler = handler
        },
        _setTitle(value) {
            this._title = value
        },
        _setMessage(value) {
            this._message = value
        },
        _preventNavigation(event) {
            if (this._allowNavigation) {
                return
            }

            event.preventDefault()
            event.returnValue = ''
        },
        async _defaultNavigateHandler() {
            const title = this._title
                ? this._title
                : this.$t('notification.areYouSure')

            return await Swal.fire({
                title,
                text: this._message,
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonColor: '#DE5B5B',
                cancelButtonText: this.$t('notification.no'),
                confirmButtonText: this.$t('notification.yesLeave'),
                customClass: 'navigation-prevent-sweet-alert',
            }).then(resp => !!resp.value)
        },
    },
}
